import { queryOptions } from "@tanstack/react-query";
import axios from "axios";

export async function fetchVersion(): Promise<string> {
  const response = await axios.get(`/version`);
  return response.data;
}

const ONE_HOUR = 60 * 60 * 1000;

export const versionCheckQueries = {
  getVersion: () =>
    queryOptions({
      queryKey: ["version"],
      queryFn: () => fetchVersion(),
      staleTime: ONE_HOUR,
      /* Refetch when user is becomes online and the query is stale. */
      refetchOnReconnect: true,
    }),
};
